// src/components/ArticleHero.jsx

import React from "react";

/**
 * Simple & modern Article Hero component with spacing
 * for a fixed header (72.8px offset).
 *
 * Props:
 * - title (string): The main heading
 * - date (string): Publication date (optional)
 * - authorName (string): The author's name (optional)
 * - authorLink (string): URL or anchor link for authorName (optional)
 * - backgroundImage (string): The hero background image path/URL
 * - ariaLabel (string): Accessible label for the section (optional)
 */
const ArticleHero = ({
  title,
  date,
  authorName,
  authorLink,
  backgroundImage,
  ariaLabel,
}) => {
  return (
    <section
      className="article-hero"
      style={{ backgroundImage: `url('${backgroundImage}')` }}
      aria-label={ariaLabel || "Article hero image"}
    >
      <div className="article-hero-content">
        <h1>{title}</h1>
        {/* Show date & author line only if provided */}
        {date && authorName && (
          <p>
            By{" "}
            {authorLink ? (
              <a href={authorLink}>{authorName}</a>
            ) : (
              <span>{authorName}</span>
            )}{" "}
            | {date}
          </p>
        )}
      </div>
    </section>
  );
};

export default ArticleHero;